import $ from 'jquery';
import cart from '@ppcp/cart';
import {registerPaymentMethod} from '@ppcp/payment-methods';
import {isPluginConnected} from '@ppcp/utils';
import {CreditCardGateway} from '../payments/classes/class-credit-card-gateway';

const card = new CreditCardGateway({
    cart,
    id: 'ppcp_card',
    context: 'checkout'
});

card.initialize().then(() => {
    $(() => {
        $(document.body).trigger('wc-credit-card-form-init');
    })
});

registerPaymentMethod(card);